import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import C from "clsx";
import n, { useContext as E, useEffect as G, useRef as H } from "react";
import { FlyoutGroup as h } from "./FlyoutGroup";
import { MenuProductHeader as L } from "./MenuProductHeader";
import { PrimaryNavContext as N } from "./PrimaryNavContext";
import { useFlyoutHeight as P } from "./hooks/useFlyoutHeight";

var S = function S(t) {
  return t > 0 ? Math.min(480, Math.max(240, t / 2)) : 0;
},
    T = function T(_ref) {
  var t = _ref.submenu;
  var u, m, p, y, c, v, d, f;

  var _E = E(N),
      g = _E.scrollbarWidth,
      l = _E.isBreakpointWithMenu,
      a = H(null),
      s = P(a.current),
      o = (m = t.elevatedGroups) == null ? void 0 : m.concat((u = t.baseGroups) != null ? u : []),
      _ = (y = (p = t.elevatedGroups) == null ? void 0 : p.length) != null ? y : 0,
      w = (c = o == null ? void 0 : o.length) != null ? c : 0,
      b = (v = o == null ? void 0 : o.reduce(function (e, r) {
    return e + r.baseLinks.length;
  }, 0)) != null ? v : 0,
      x = l ? null : S(s);

  return G(function () {
    var e = function e() {
      var r = window.innerHeight,
          i = s + 80;
      r < i ? a.current.classList.add("hg-primarynav__flyout--short") : a.current.classList.remove("hg-primarynav__flyout--short");
    };

    return window.addEventListener("resize", e), e(), function () {
      window.removeEventListener("resize", e);
    };
  }), n.createElement("div", {
    ref: a,
    id: "hg-primarynav__submenu-link--".concat(t.id),
    className: C("hg-primarynav__flyout", "hg-primarynav__submenu"),
    style: {
      "--primarynav-flyout-rate": l ? null : "".concat(x, "ms"),
      "--primarynav-flyout-height": l ? null : "".concat(s, "px"),
      "--primarynav-scrollbar-width": "".concat(g, "px")
    }
  }, n.createElement("div", {
    className: "hg-primarynav__flyout-scroll-container"
  }, n.createElement(L, {
    title: t.title
  }), n.createElement("div", {
    className: "hg-primarynav__flyout-content hg-primarynav__submenu-content",
    style: {
      "--primarynav-flyout-elevated-group-count": _,
      "--primarynav-flyout-group-count": w,
      "--primarynav-flyout-item-total": b
    }
  }, (d = t.elevatedGroups) == null ? void 0 : d.map(function (e, r) {
    return n.createElement(h, {
      key: e.id,
      group: e,
      groupNumber: r,
      isElevated: !0
    });
  }), (f = t.baseGroups) == null ? void 0 : f.map(function (e, r) {
    var i;
    return n.createElement(h, {
      key: e.id,
      group: e,
      groupNumber: (((i = t.elevatedGroups) == null ? void 0 : i.length) || 0) + r
    });
  }))));
};

export { T as Flyout };